import * as yup from 'yup';

export const validationParamSchema = yup.object({
    //productName: yup
    //    .string()
    //    .typeError("Must be a valid string"),
    //supplierName: yup
    //    .string()
    //    .typeError("Must be a valid string")
})